<template>
  <b-container fluid>
    <b-form @submit.prevent="saveTherapy">
      <b-row cols="1" class="my-2">
        <h2 class="section-title">
          {{$t('NewTherapy.titoloPatologia')}}
        </h2>
        <div class="text-left">
          <div class="filter-chips">
            <button type="button" class="filter-chip" :class="{ 'filter-chip--active': hasPathology === 1 }" @click="hasPathology = 1">{{$t('NewTherapy.indicaPatologia')}}</button>
            <button type="button" class="filter-chip" :class="{ 'filter-chip--active': hasPathology === 0 }" @click="hasPathology = 0">{{$t('NewTherapy.nonIndicare')}}</button>
          </div>
          <b-row
            v-if="hasPathology === 1"
            class="my-2 mt-4 col-12 px-0 align-items-center align-content-center flex-wrap my-2"
          >
            <PatologieComponent
              :subject="subject"
              v-on:selected-pathology="selectPathology($event)"
            />
          </b-row>
        </div>
      </b-row>
      <b-row cols="1" class="pt-2" :class="hasPathology ? '' : 'mt-3'">
        <h2 class="section-title">{{$t('NewTherapy.farmacoIndicato')}}</h2>
        <div class="text-left mb-4">
          <b-row cols="1" class="shadowedCard p-4 mx-0">
            <b-col class="px-0 px-md-2">
              <b-form-group
                :label="$t('NewTherapy.labelCercaFarmaco')"
                class="col-12 px-0 col-md-10 pl-0"
              >
                <div class="search-field">
                  <b-form-input
                  v-capitalize-first
                  class=" "
                  type="search"
                  name="pharmasearch"
                  :placeholder="$t('NewTherapy.placeholderCercaFarmaco')" 
                  v-model="prodSearch.q"
                  v-debounce:500ms="searchProds"
                  :debounce-events="'keyup'"
                >
                </b-form-input>
                  <b-icon icon="search" class="search-field__icon" aria-hidden="true"></b-icon>
                </div>
              </b-form-group>
              <b-spinner
                v-show="isSearching"
                class="ml-4"
                variant="primary"
                :label="$t('caricamento')"
              ></b-spinner>
            </b-col>

            <b-col v-if="products" class="px-0 px-md-2 pt-2">
              <b-form-group
                :label="$t('NewTherapy.labelSelezionaFarmaco')"
                class="col-12 col-md-10 pl-0"
              >
                <b-form-select
                  v-capitalize-first-select
                  v-model="selectedProduct"
                  class=""
                >
                  <b-form-select-option
                    v-for="(prod, ind) in products"
                    :key="ind"
                    :value="prod"
                    >{{ prod.Nome }}
                  </b-form-select-option>
                  <b-form-select-option :value="null" disabled
                    >---</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col v-if="showNotFound">
              <p class="text-danger">{{$t('NewTherapy.prodottoNonTrovato')}}</p>
            </b-col>
          </b-row>
        </div>
      </b-row>
      <b-row cols="1" class="mt-4" v-if="selectedProduct">
        <h2 class="section-title">
          {{$t('NewTherapy.frequenzaModalitaDosaggio')}}
        </h2>
        <div class="text-left">
          <div class="mt-4 shadowedCard p-4">
            <h6
              v-if="selectedProduct.Nome"
              class="tint-box tint-box--sm text-uppercase mb-3"
            >
              <span class="pl-2">
                {{ selectedProduct.Nome }}
              </span>
            </h6>
            <b-row class="align-items-end px-1 my-2">
              <b-col class="col-6 col-md-2 align-items-end px-0 px-md-2">
                <b-form-group class="" :label="$t('NewTherapy.dosaggio')">
                  <b-form-input
                    class=" "
                    type="number"
                    step="0.25"
                    min="0.25"
                    v-model="form.posology_num"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="ml-1 col-11 col-md-7 px-0 px-md-2">
                <b-form-group label="" class="">
                  <b-form-select
                    v-capitalize-first-select
                    id="posology-type-select"
                    v-model="form.posology_type"
                    class="w-auto"
                  >
                    <b-form-select-option
                      v-for="type in posologyTypes"
                      :key="type"
                      :value="type"
                      >{{ type }}
                    </b-form-select-option>
                    <b-form-select-option :value="null" disabled
                      >---</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="align-items-end px-1 my-2">
              <b-col class="ml-2 col-12 col-md-3 col-lg-2 pl-0">
                <b-form-group class="mt-2" :label="$t('NewTherapy.frequenza')">
                  <b-form-radio-group
                    v-model="form.posology_every_type"
                    name="posology-every-type-options"
                  >
                    <b-form-radio :value="0">{{$t('NewTherapy.alDi')}}</b-form-radio>
                    <b-form-radio :value="2">{{$t('NewTherapy.alBisogno')}}</b-form-radio>
                    <b-form-radio :value="1">{{$t('NewTherapy.ogni')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col
                v-if="form.posology_every_type === 1"
                class="ml-0 col-11 col-md-7 d-flex align-items-center"
              >
                <b-form-group class="my-auto ml-0">
                  <b-input-group class="align-items-center">
                    <b-form-input
                      class=" "
                      type="number"
                      step="1"
                      min="1"
                      max="36"
                      v-model="form.posology_every_num"
                    >
                    </b-form-input>
                    <!-- <span class="ml-3">Ore</span>
                  <b-input-group-append></b-input-group-append> -->
                  </b-input-group>
                </b-form-group>
                <b-form-group class="my-auto ml-4" label="">
                  <b-form-radio-group
                    v-model="form.posology_every_um"
                    name="posology-every-um-options"
                  >
                    <b-form-radio :value="1">{{$t('NewTherapy.ore')}}</b-form-radio>
                    <b-form-radio :value="0">{{$t('NewTherapy.giorni')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="px-1 my-2">
              <b-col class="ml-2 col-11 col-md-10 px-0 pl-md-0">
                <b-form-group
                  label="Per via*"
                  class="col-12 col-md-5 col-lg-3 px-0"
                >
                  <b-form-select
                    v-capitalize-first-select
                    v-model="form.posology_via"
                    class="max-width-150px"
                  >
                    <b-form-select-option
                      v-for="via in posologyVias"
                      :key="via"
                      :value="via"
                      >{{ via }}
                    </b-form-select-option>
                    <b-form-select-option :value="null" disabled
                      >---</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-col>
              <b-form-group :label="$t('NewTherapy.daAssumere')">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-model="form.mattina"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.meta_mattina ||
                        form.pranzo ||
                        form.pomeriggio ||
                        form.sera ||
                        form.notte)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.mattina')}}</b-form-checkbox
                  >

                  <b-form-checkbox
                    v-model="form.meta_mattina"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.mattina ||
                        form.pranzo ||
                        form.pomeriggio ||
                        form.sera ||
                        form.notte)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.metaMattina')}}</b-form-checkbox
                  >

                  <b-form-checkbox
                    v-model="form.pranzo"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.mattina ||
                        form.meta_mattina ||
                        form.pomeriggio ||
                        form.sera ||
                        form.notte)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.pranzo')}}</b-form-checkbox
                  >

                  <b-form-checkbox
                    v-model="form.pomeriggio"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.mattina ||
                        form.meta_mattina ||
                        form.pranzo ||
                        form.sera ||
                        form.notte)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.pomeriggio')}}</b-form-checkbox
                  >

                  <b-form-checkbox
                    v-model="form.sera"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.mattina ||
                        form.meta_mattina ||
                        form.pranzo ||
                        form.pomeriggio ||
                        form.notte)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.sera')}}</b-form-checkbox
                  >

                  <b-form-checkbox
                    v-model="form.notte"
                    :disabled="
                      blockMoreThanOneAssunzioni &&
                      (form.mattina ||
                        form.meta_mattina ||
                        form.pranzo ||
                        form.pomeriggio ||
                        form.sera)
                    "
                    class="mr-4"
                    >{{$t('NewTherapy.notte')}}</b-form-checkbox
                  >
                </div>
              </b-form-group>

              <p
                class="text-danger fs-5"
                v-if="
                  blockMoreThanOneAssunzioni &&
                  (form.mattina ||
                    form.meta_mattina ||
                    form.pranzo ||
                    form.pomeriggio ||
                    form.sera ||
                    form.notte)
                "
              >
                {{$t('NewTherapy.maxUnoAssunzione')}}
              </p>

              <!-- Alert 10 minuti prima della somministrazione -->
              <b-form-group
                v-if="showAlertOption"
                class="mt-3"
                label-for="alert-checkbox"
                :description="$t('NewTherapy.inviaAlert')"
              >
                <b-form-checkbox
                  id="alert-checkbox"
                  v-model="form.send_alert"
                  name="send_alert"
                  :value="true"
                  :unchecked-value="false"
                  :disabled="!hasAtLeastOneAssunzione"
                >
                  {{$t('NewTherapy.inviaAlert')}}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </div>
        </div>
      </b-row>

      <b-row cols="1" class="mt-4 pt-4">
        <h2 class="section-title">
          {{$t('NewTherapy.durataTerapia')}}
        </h2>
        <div class="text-left shadowedCard p-4 mt-1">
          <div class="filter-chips">
            <button type="button" class="filter-chip" :class="{ 'filter-chip--active': form.type === 0 }" @click="form.type = 0">{{$t('NewTherapy.indeterminata')}}</button>
            <button type="button" class="filter-chip" :class="{ 'filter-chip--active': form.type === 1 }" @click="form.type = 1">{{$t('NewTherapy.periodica')}}</button>
            <button type="button" class="filter-chip" :class="{ 'filter-chip--active': form.type === 2 }" @click="form.type = 2">{{$t('NewTherapy.occasionale')}}</button>
          </div>

          <b-row
            v-if="form.type === 1"
            cols="2"
            class="mt-4 col-12 px-0 align-items-center"
          >
            <b-col class="col-md-6 col-12 px-0 px-md-2">
              <b-row cols="2" class="align-items-end">
                <b-col class="col-md-5 col-12 px-0 px-md-2">
                  <b-form-group label="Per " class="">
                    <b-form-input
                      class=" "
                      type="number"
                      step="1"
                      min="1"
                      max="60"
                      v-model="form.for_num"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="ml-2 col-md-6 col-12 px-0 px-md-2">
                  <b-form-radio-group
                    v-model="form.for_um"
                    name="for-ums-options"
                    class="my-3"
                  >
                    <b-form-radio :value="0">{{$t('NewTherapy.mesi')}}</b-form-radio>
                    <b-form-radio :value="1">{{$t('NewTherapy.settimane')}}</b-form-radio>
                    <b-form-radio :value="2">{{$t('NewTherapy.giorni')}}</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-md-6 col-12 px-0 px-md-2">
              <b-row cols="2" class="align-items-end">
                <b-col class="col-md-5 col-12 px-0 px-md-2">
                  <b-form-group :label="$t('NewTherapy.ogni')" class="">
                    <b-form-input
                      class=" "
                      type="number"
                      step="1"
                      min="1"
                      max="60"
                      v-model="form.every_num"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="ml-2 col-md-6 col-12 px-0 px-md-2">
                  <b-form-radio-group
                    v-model="form.every_um"
                    name="every-ums-options"
                    class="my-3"
                  >
                    <b-form-radio :value="0">{{$t('NewTherapy.mesi')}}</b-form-radio>
                    <b-form-radio :value="1">{{$t('NewTherapy.settimane')}}</b-form-radio>
                    <b-form-radio :value="2">{{$t('NewTherapy.giorni')}}</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row
            cols="1"
            cols-md="2"
            class="text-left mt-3"
            v-if="form.type >= 1"
          >
            <b-col class="px-0 px-md-2">
              <b-form-group
                :label="$t('NewTherapy.aPartireDal')"
                label-for="start_at"
                class="text-left mx-auto"
              >
                <b-form-input
                  class="my-3"
                  name="start_at"
                  type="date"
                  v-model="form.start_at"
                  required
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="px-0 px-md-2" v-if="form.type > 1">
              <b-form-group
                :label="$t('NewTherapy.finoAl')"
                label-for="end_at"
                class="text-left mx-auto"
              >
                <b-form-input
                  class="my-3"
                  name="end_at"
                  type="date"
                  v-model="form.end_at"
                  required
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-row>
      <template v-if="selectedProduct">
        <b-row cols="1" class="my-3 pt-2" v-if="!subject">
          <b-col class="px-0">
            <b-form-group
              label=""
              :description="$t('NewTherapy.visibileSoloMe')"
              label-for="private"
              class="text-left"
            >
              <b-form-checkbox
                id="private"
                v-model="form.private"
                name="private"
                :value="true"
                :unchecked-value="false"
              >
                {{$t('NewTherapy.visibileSoloMe')}}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row cols="1">
          <h2 class="section-title">{{$t('NewTherapy.dettagli')}}</h2>
          <b-col class="px-0">
            <b-row class="shadowedCard p-4" cols="2">
              <b-col>
                <b-form-group
                  :label="$t('NewTherapy.prescrittore')"
                  label-for="prescrittore"
                  class="text-left mx-auto"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3"
                    name="prescrittore"
                    type="date"
                    v-model="form.prescrittore"
                    required
                  >
                    <b-form-select-option
                      v-for="ikey in irstKeys.prescr"
                      :key="ikey.descrizione"
                      :value="ikey.descrizione"
                      >{{ ikey.descrizione }}</b-form-select-option
                    >
                    <b-form-select-option :value="null"
                      >{{$t('NewTherapy.indicaPrescrittore')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="subject">
                <b-form-group
                  :label="$t('NewTherapy.fonte')"
                  label-for="fonte"
                  class="text-left mx-auto"
                >
                  <b-form-select
                    v-capitalize-first-select
                    class="my-3"
                    name="fonte"
                    type="date"
                    v-model="form.fonte_informativa"
                    required
                  >
                    <b-form-select-option
                      v-for="ikey in irstKeys.fonte"
                      :key="ikey.descrizione"
                      :value="ikey.descrizione"
                      >{{ ikey.descrizione }}</b-form-select-option
                    >
                    <b-form-select-option :value="null"
                      >{{$t('NewTherapy.indicaFonte')}}</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('NewTherapy.effettiCollaterali')"
                  label-for="effetti_collaterali"
                  class="text-left mx-auto"
                >
                  <b-form-textarea
                    v-capitalize-first
                    class="my-3"
                    name="effetti_collaterali"
                    type="text"
                    :placeholder="$t('NewTherapy.placeholderEffetti')" 
                    v-model="form.effetti_collaterali"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('NewTherapy.reazioniAllergiche')"
                  label-for="reazione_allergica"
                  class="text-left mx-auto"
                >
                  <b-form-textarea
                    v-capitalize-first
                    class="my-3"
                    name="reazione_allergica"
                    type="text"
                    :placeholder="$t('NewTherapy.placeholderAllergie')"
                    v-model="form.reazione_allergica"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :label="$t('NewTherapy.interazioni')"
                  label-for="interazioni"
                  class="text-left mx-auto"
                >
                  <b-form-textarea
                    v-capitalize-first
                    class="my-3"
                    name="interazioni"
                    type="text"
                    :placeholder="$t('NewTherapy.placeholderInterazioni')" 
                    v-model="form.interazioni"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row cols="1" class="mt-4 pt-3">
          <b-col class="px-0">
            <h4 class="text-left pb-3 mt-3">{{$t('NewTherapy.annotazioni')}}</h4>
            <b-form-group label-for="details" class="text-left text-dark-grey">
              <b-form-textarea
                v-capitalize-first
                class="my-3"
                name="details"
                type="text"
                v-model="form.details"
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row cols="1" class="my-3">
          <b-col class="px-0 px-md-2">
            <b-button type="submit" variant="secondary">{{$t('NewTherapy.salva')}}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-form>
  </b-container>
</template>
<script>
import * as moment from "moment/moment";
import { utilityService, cittadinoService } from "@/_services";
import PatologieComponent from "@/app/modules/servizi/profiloSanitario/components/PatologieComponent.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "NewTherapy",
  props: ["subject"],
  components: { PatologieComponent },
  data() {
    return {
      form: {
        type: 0,
        start_at: null,
        end_at: null,
        details: null,
        own: true,
        private: false,
        subjectable_id: null,
        subjectable_type: null,
        chronic: true,
        pathology_id: null,
        every_num: 1,
        every_um: 0,
        for_num: 1,
        for_um: 0,
        posology_num: 1,
        posology_type: "Compresse",
        posology_via: "Orale",
        posology_every_num: 1,
        posology_every_um: 0,
        posology_every_type: 0,
        product_name: null,
        product_aic: null,
        prescrittore: null,
        fonte_informativa: null,
        effetti_collaterali: null,
        reazione_allergica: null,
        interazioni: null,
        mattina: false,
        meta_mattina: false,
        pranzo: false,
        pomeriggio: false,
        sera: false,
        notte: false,
        send_alert: false,
      },
      hasPathology: 0,
      everyUms: {
        0: this.$t('NewTherapy.everyUms.0'),
        1: this.$t('NewTherapy.everyUms.1'),
        2: this.$t('NewTherapy.everyUms.2'),
      },
      everyPosologyTypes: {
        0: this.$t('NewTherapy.everyPosologyTypes.0'),
        1: this.$t('NewTherapy.everyPosologyTypes.1'),
        2: this.$t('NewTherapy.everyPosologyTypes.2'),
      },
      everyPosologyUms: {
        1: this.$t('NewTherapy.everyPosologyUms.1'),
        2: this.$t('NewTherapy.everyPosologyUms.2'),
      },
      posologyTypes: [
        this.$t('NewTherapy.posologyTypes.Compresse'),
          this.$t('NewTherapy.posologyTypes.Capsule'),
          this.$t('NewTherapy.posologyTypes.Gocce'),
          this.$t('NewTherapy.posologyTypes.Inalazioni'),
          this.$t('NewTherapy.posologyTypes.Buste'),
          this.$t('NewTherapy.posologyTypes.Supposte'),
          this.$t('NewTherapy.posologyTypes.Scatole'),
          this.$t('NewTherapy.posologyTypes.Cerotti'),
          this.$t('NewTherapy.posologyTypes.Fiale'),
          this.$t('NewTherapy.posologyTypes.Fleboclisi'),
          this.$t('NewTherapy.posologyTypes.Ovuli'),
          this.$t('NewTherapy.posologyTypes.Sacche'),
          this.$t('NewTherapy.posologyTypes.Flaconi'),
          this.$t('NewTherapy.posologyTypes.Confezioni'),
          this.$t('NewTherapy.posologyTypes.Kilogrammi'),
          this.$t('NewTherapy.posologyTypes.Kit'),
          this.$t('NewTherapy.posologyTypes.Millilitri'),
          this.$t('NewTherapy.posologyTypes.Milligrammi'),
      ],
      posologyVias: [
        this.$t('NewTherapy.posologyVias.Orale'),
        this.$t('NewTherapy.posologyVias.Transdermica'),
        this.$t('NewTherapy.posologyVias.Nasale'),
        this.$t('NewTherapy.posologyVias.Endovena'),
        this.$t('NewTherapy.posologyVias.Intramuscolo'),
        this.$t('NewTherapy.posologyVias.Oftalmica'),
        this.$t('NewTherapy.posologyVias.Rettale'),
        this.$t('NewTherapy.posologyVias.Uretale'),
        this.$t('NewTherapy.posologyVias.Vaginale'),
        this.$t('NewTherapy.posologyVias.Sottocute'),
      ],
      pathologies: null,
      typesColors: ["ter-4", "ter-1", "ter-2"],
      prodSearch: {
        q: null,
      },
      products: null,
      selectedProduct: null,
      isSearching: false,
      showNotFound: false,
      irstKeys: null,
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    blockMoreThanOneAssunzioni() {
      return this.posologyIsAlDi || this.posologyIsOgniNgiorni;
    },
    posologyIsAlDi() {
      return this.form.posology_every_type === 0;
    },
    posologyIsOgniNgiorni() {
      return (
        this.form.posology_every_type === 1 && this.form.posology_every_um === 0
      );
    },
    showAlertOption() {
      // Mostra l'opzione alert quando la frequenza è "al dì" (0) o "ogni" (1)
      return this.form.posology_every_type === 0 || this.form.posology_every_type === 1;
    },
    hasAtLeastOneAssunzione() {
      // Verifica se almeno una delle opzioni "Da assumere" è selezionata
      return (
        this.form.mattina ||
        this.form.meta_mattina ||
        this.form.pranzo ||
        this.form.pomeriggio ||
        this.form.sera ||
        this.form.notte
      );
    },
  },
  watch: {
    prodSearch: {
      handler(val) {
        if (val.q == null || val.q.length < 3) {
          this.products = null;
          this.selectedProduct = null;
        }
      },
      deep: true,
    },
    selectedProduct: {
      handler(val) {
        if (val !== null) {
          this.form.product_name = val.Nome;
          this.form.product_aic = val.Aic;
          this.form.product_principio_attivo = val.PrincipioAttivo;
          this.form.product_codice_principio_attivo = val.CodicePrincipioAttivo;
        }
      },
      deep: true,
    },
    "form.posology_every_type": function (newVal, oldVal) {
      this.checkMaxAssunzioni();
    },
    "form.posology_assunzioni": function (newVal, oldVal) {
      this.checkMaxAssunzioni();
    },
    "form.posology_every_um": function (newVal, oldVal) {
      this.checkMaxAssunzioni();
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    formatData(data) {
      return moment(data).format("DD MMM YYYY");
    },
    selectPathology(pathology) {
      this.form.pathology_id = pathology.hashid;
      this.form.chronic = pathology.type === 0;
      this.form.type = pathology.type !== 0 ? 2 : 0;
    },
    searchProds() {
      if (this.prodSearch.q && this.prodSearch.q.length >= 3) {
        this.isSearching = true;
        var self = this;
        this.showNotFound = false;
        utilityService
          .products(this.prodSearch)
          .then(function (response) {
            // console.log(response.data instanceof Array);
            self.products = response.data;
            if (!(response.data instanceof Array)) {
              self.products = [response.data];
            }
            self.isSearching = false;
          })
          .catch(function (error) {
            self.showNotFound = true;
            self.isSearching = false;
          });
      } else if (!this.selectedProduct) {
        this.products = null;
      }
    },
    saveTherapy() {
      //flatten assunzioni

      var self = this;
      cittadinoService
        .storeTherapy(this.form)
        .then(function (response) {
          self.$emit("save-therapy", response.data.data);
          self.successAlert(self.$t('NewTherapy.successSalvataggio'));
        })
        .catch(function (error) {
          console.log(error);
          self.errorAlert(self.$t('NewTherapy.erroreSalvataggio'));
        });
    },
    getKeys() {
      var filters = {
        key: "prescr,fonte",
      };
      var self = this;
      utilityService
        .getIrstKeys(filters)
        .then(function (res) {
          self.irstKeys = res.data.data;
        })
        .catch(function (err) {
          {
            self.errorAlert(self.$t('NewTherapy.erroreGenerico'));
          }
        });
    },
    checkMaxAssunzioni() {
      if (this.blockMoreThanOneAssunzioni) {
        const assunzioni = [
          this.form.mattina,
          this.form.meta_mattina,
          this.form.pranzo,
          this.form.pomeriggio,
          this.form.sera,
          this.form.notte,
        ];

        if (assunzioni.filter((a) => a).length > 1) {
          this.form.mattina = false;
          this.form.meta_mattina = false;
          this.form.pranzo = false;
          this.form.pomeriggio = false;
          this.form.sera = false;
          this.form.notte = false;
        }
      }
    },
  },
  created() {
    if (this.subject) {
      this.form.subjectable_id = this.subject.hashid;
      this.form.subjectable_type = this.subject.type;
      this.form.own = false;
    }
    this.getKeys();
  },
  mounted() {
    var today = moment();
    this.form.start_at = today.format("YYYY-MM-DD");
    if (this.$route.query.pax != undefined) {
      this.hasPathology = 1;
    }
  },
};
</script>

